$(document).ready(() => {
  $(window).scroll(() => {

    if($(window).scrollTop()>200) {
      // $('body.is-home nav.navbar').height(40)
      $('body.is-home .navbar-brand img').height(40)
      $('body.is-home .home-background-filter').css('opacity', '1')
    } else if (!$('#navbarSupportedContent').hasClass('show')) {
      // $('body.is-home nav.navbar').height(134)
      $('body.is-home .navbar-brand img').height(130)
      $('body.is-home .home-background-filter').css('opacity', '0.70')
    }

  });
})


// WEBPACK FOOTER //
// ./js/inc/scrolltop.js